import styles from 'css/src/components/video-planner/VideoInfoChip.module.scss';

import React, { useCallback } from 'react';
import classNames from 'classnames';

import Tooltip from 'js/src/components/common/ui/Tooltip';

export interface VideoInfoChipProps {
    icon: string;
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    tooltip?: string;
    testId?: string;
    className?: string;
}

export const VideoInfoChip: React.FC<VideoInfoChipProps> = ({
    icon,
    label,
    onClick,
    disabled = false,
    tooltip,
    testId,
    className,
}) => {
    const isInteractive = !!onClick && !disabled;

    const handleClick = useCallback(() => {
        if (!isInteractive) return;
        onClick?.();
    }, [onClick, isInteractive]);

    const chipContent = (
        <div
            className={classNames(
                styles['video-info-chip'],
                'd-inline-flex align-items-center gap-1',
                'font-l5 font-l5--small',
                className,
                {
                    [styles['video-info-chip--interactive']]: isInteractive,
                    [styles['video-info-chip--disabled']]: disabled,
                },
            )}
            onClick={handleClick}
            role={isInteractive ? 'button' : undefined}
            tabIndex={isInteractive ? 0 : undefined}
            data-testid={testId}
            aria-disabled={disabled}
        >
            <span
                translate="no"
                className={`material-symbols-outlined ${styles['video-info-chip__icon']}`}
            >
                {icon}
            </span>
            <span className={`${styles['video-info-chip__label']} text-nowrap`}>{label}</span>
        </div>
    );

    if (tooltip) {
        return (
            <Tooltip title={tooltip} trigger="hover">
                {chipContent}
            </Tooltip>
        );
    }

    return chipContent;
};
